// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Loading-module__fullscreen__12oH7{display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;position:fixed;top:0;bottom:0;left:0;right:0;padding:24px}.Loading-module__text__mrOHw{margin-top:32px}", ""]);
// Exports
exports.locals = {
	"fullscreen": "Loading-module__fullscreen__12oH7",
	"text": "Loading-module__text__mrOHw"
};
export default exports;
